import React, { useCallback } from 'react';
import { Card, Heading, Row, Text, Box, Input } from '../core';
import { StatusButton } from '../StatusButton';
import {
  HedgedLP,
  usePriceOffsetSlippage,
  useSend,
  useCall2,
  useInputState,
} from '@sc1/common';
import { CardProps } from 'theme-ui';

interface RemoveLiquidityProps extends CardProps {
  strategy: HedgedLP;
  disabled: boolean;
}

export const RemoveLiquidity = ({
  strategy,
  disabled,
  sx,
  ...rest
}: RemoveLiquidityProps): JSX.Element => {
  const { amountStr, amountBN, setAmount } = useInputState();

  const { sendTx, txStatus } = useSend();
  const { res: dec } = useCall2(strategy?.decimals);
  const { slippage, slippageDescription } = usePriceOffsetSlippage(strategy);

  const removeLiquidity = useCallback(() => {
    if (!strategy || !slippage) return;
    if (amountStr === '') return; // avoid unintentional 0 input
    sendTx(strategy, 'removeLiquidity', [amountBN, slippage]);
  }, [strategy, amountStr, amountBN, slippage]);

  return (
    <Card sx={{ ...sx }} {...rest}>
      <Heading mb={2} as="h3">
        Remove Liquidity
      </Heading>
      <Row variant="collapse">
        <Input
          value={amountStr}
          disabled={disabled}
          min="0"
          placeholder="0"
          type="number"
          onChange={(e) => {
            setAmount(e.target.value, dec);
          }}
        />
        <Box my={1} mx={1} />
        <StatusButton
          disabled={disabled}
          onClick={removeLiquidity}
          status={txStatus}
        >
          Submit
        </StatusButton>
      </Row>
      <Box variant="text.info" my={1}>
        {slippageDescription}
      </Box>
      {amountStr !== '' && (
        <Text sx={{ mt: 2, fontSize: 1 }}>
          Fmt LP Amnt: {amountBN?.toString()}
        </Text>
      )}
    </Card>
  );
};
